import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { TopEventsSportState } from 'src/main/cms/TopEvents/topEventsState/TopEventsSportState';
import { TopEventsEventCompetitionState } from 'src/main/cms/TopEvents/topEventsState/TopEventsCompetitionState';
import { TopEventsEventState } from 'src/main/cms/TopEvents/topEventsState/TopEventsEventsState';
import {
    TopEventsEventsState,
    EventCombinedType,
    CompetitionCombinedType,
} from 'src/AppState/CmsState/TopEventsState/TopEventsState';
import { ListItemSecondary } from 'src/domains/layouts/shared/cms/list/listItems/ListItemSecondary';
import { useAppStateContext } from 'src/AppState/AppState';

interface SportSectionPropsType {
    label: string;
    isOpen: boolean;
    isDragged: boolean;
    topEventsEventSportState: TopEventsSportState;
    dataTest?: string;
}

export const TopEventsEventSportSection = observer(
    'TopEventsEventSportSection',
    ({ label, isOpen, isDragged, topEventsEventSportState, dataTest }: SportSectionPropsType) => {
        const {
            setSportActive,
            isActive,
            handleToggleOpenSection,
            handleDeleteSport,
            handleShowDeletePopup,
            handleHideDeletePopup,
            showDeletePopup,
        } = topEventsEventSportState;

        return (
            <ListItemSecondary
                label={label}
                isDragged={isDragged}
                setPublished={setSportActive}
                isPublished={isActive}
                handleToggleOpenSection={handleToggleOpenSection}
                isOpenSection={isOpen}
                handleDelete={handleDeleteSport}
                handleDragAndDrop={true}
                hasSubsection={true}
                handleShowDeletePopup={handleShowDeletePopup}
                handleHideDeletePopup={handleHideDeletePopup}
                showDeletePopup={showDeletePopup}
                dataTest={dataTest}
            />
        );
    }
);

interface CompetitionSectionPropsType {
    label: string;
    isOpen: boolean;
    isDragged: boolean;
    topEventsEventCompetitionState: TopEventsEventCompetitionState;
    dataTest?: string;
}

export const TopEventsEventCompetitionSection = observer(
    'TopEventsEventCompetitionSection',
    ({ label, isOpen, isDragged, topEventsEventCompetitionState, dataTest }: CompetitionSectionPropsType) => {
        const {
            setCompetitionActive,
            isActive,
            handleToggleOpenSection,
            handleDeleteCompetition,
            handleShowDeletePopup,
            handleHideDeletePopup,
            showDeletePopup,
        } = topEventsEventCompetitionState;

        return (
            <ListItemSecondary
                label={label}
                setPublished={setCompetitionActive}
                isPublished={isActive}
                isDragged={isDragged}
                handleDragAndDrop={true}
                hasSubsection={true}
                subsection='one'
                handleToggleOpenSection={handleToggleOpenSection}
                isOpenSection={isOpen}
                handleDelete={handleDeleteCompetition}
                handleShowDeletePopup={handleShowDeletePopup}
                handleHideDeletePopup={handleHideDeletePopup}
                showDeletePopup={showDeletePopup}
                dataTest={dataTest}
            />
        );
    }
);

interface EventSectionPropsType {
    eventData: EventCombinedType;
    getCompetitionData: (competitionId: number) => CompetitionCombinedType | null;
    handleDeleteCompetition: (sportSlug: string) => Promise<void>;
    isDragged: boolean;
    topEventsEventsSectionState: TopEventsEventsState;
    dataTest?: string;
}

export const TopEventsEventSection = observer(
    'TopEventsEventSection',
    ({
        eventData,
        getCompetitionData,
        handleDeleteCompetition,
        topEventsEventsSectionState,
        isDragged,
        dataTest,
    }: EventSectionPropsType) => {
        const { sdkStaff, trpcClient } = useAppStateContext();
        const [topEventsEventState] = useState(
            () =>
                new TopEventsEventState(
                    trpcClient,
                    sdkStaff,
                    eventData,
                    getCompetitionData,
                    handleDeleteCompetition,
                    topEventsEventsSectionState
                )
        );

        const {
            setEventActive,
            isActive,
            handleDeleteEvent,
            handleShowDeletePopup,
            handleHideDeletePopup,
            showDeletePopup,
            isEventFinished,
            eventName,
        } = topEventsEventState;

        if (isEventFinished === null || isEventFinished) {
            return null;
        }

        return (
            <ListItemSecondary
                label={eventName}
                subsection='two'
                setPublished={setEventActive}
                handleDragAndDrop={true}
                isPublished={isActive}
                isDragged={isDragged}
                handleDelete={handleDeleteEvent}
                handleShowDeletePopup={handleShowDeletePopup}
                handleHideDeletePopup={handleHideDeletePopup}
                showDeletePopup={showDeletePopup}
                dataTest={dataTest}
            />
        );
    }
);
